import type { IconData } from '@stacksjs/iconify-core'

export const shortText: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M128 192h256v32H128zm0 112h128v32H128z\"/><path fill=\"currentColor\" d=\"M48 432h416V88H48Zm32-312h352v280H80Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default shortText
